import {useGuestVariables} from 'Event'
import SubmitButtonConfig from 'Event/auth/ForgotPassword/SubmitButton/SubmitButtonConfig'
import Button from 'Event/auth/Login/SubmitButton/Button'
import {useTemplate} from 'Event/TemplateProvider'
import Configurable from 'organization/Event/Configurable'
import React from 'react'

export default function SubmitButton(props: {submitting: boolean}) {
  const v = useGuestVariables()
  const {login} = useTemplate()

  return (
    <Configurable>
      <SubmitButtonConfig />
      <Button disabled={props.submitting} aria-label="submit reset password">
        {v(login.passwordReset?.buttonText)}
      </Button>
    </Configurable>
  )
}
